import { html, LitElement, css, unsafeCSS } from 'lit';

import style from './builds.scss';

import { BuildListComponent } from '../components/buildlist';
import { DATA_CLASSES, DATA_VERSIONS } from '../data/sources';
import { loadURLParams, setTitle, trackPage } from '../shared/utils';
import { DIFFICULTY } from '../shared/types';

export class BuildsPage extends LitElement {

    constructor() {
        super();
        this.buildlist = new BuildListComponent();
        this.diff = '';
        this.class = '';
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        trackPage();
        let params = {
            diff: '',
            class: ''
        };
        loadURLParams(params);
        this.diff = params.diff;
        this.class = params.class;
        this.fetchData();
        setTitle('Builds');
    }

    async fetchData() {
        this.buildlist.url = `builds?diff=${this.diff}&class=${this.class}`;
        this.buildlist.fetchData();
    }

    updateURL(){
        if(window.history){                        
            window.history.replaceState(null, document.title, `./builds?diff=${this.diff}&class=${this.class}`);
            window.dispatchEvent(new PopStateEvent('popstate'));
        }
    }

    render() {  
        return html`            
            <select @change=${(ev)=>{
                    this.diff = ev.target.value;
                    this.updateURL();
                    this.fetchData();
                }}>
                <option value="">-- Difficulty --</option>
                ${DIFFICULTY.map((val,i)=>{
                    if(val)
                        return html`<option value="${val}" ?selected=${this.diff === val}>${val}</option>`;
                })}
            </select>  
            <select @change=${(ev)=>{
                    this.class = ev.target.value;
                    this.updateURL();
                    this.fetchData();
                }}>
                <option value="">-- Class --</option>
                ${[...DATA_CLASSES,{name:'Sunforge',value:'Scion'}].map((val,i)=>{
                    if(val)
                        return html`<option value="${val.value || val.name}" ?selected=${this.class === (val.value || val.name)}>${val.name}</option>`;
                })}
            </select>          
            <div class="bubble big" style="float:right"><a href="./build/create">New Build</a></div>       
            ${this.buildlist}
        `;
    }
}

customElements.define('builds-page', BuildsPage);